import { render } from "./Photograph.vue?vue&type=template&id=62f4c704"
import script from "./Photograph.vue?vue&type=script&lang=js"
export * from "./Photograph.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "62f4c704"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62f4c704', script)) {
    api.reload('62f4c704', script)
  }
  
  module.hot.accept("./Photograph.vue?vue&type=template&id=62f4c704", () => {
    api.rerender('62f4c704', render)
  })

}

script.__file = "src/icons/components/filled/Photograph.vue"

export default script